import { formatTestId } from '../../util/EfupUtility';
import { Link } from "react-router-dom";

const CollapsibleMenu = props => {
    const key = Math.random();
    const testId = formatTestId(`collapsible-menu-item-${props.title}`);
    //if submenu item is also a hyperlink, add the submenu-link css class
    const menuClass = props.link ? "submenu-link" : "";

    function handleChange() {
        let isChecked = document.getElementById(key).checked;
        document.getElementById(key).checked = !isChecked;
    };

    return (
        <li>
            <input id={key} type="checkbox" hidden onChange={handleChange} />
            { props.link ?
                <span className={menuClass}>
                    <Link to={{pathname: props.link}} data-testid={testId} >{props.title}</Link>
                    <i data-testid={`${testId}-dropdown`} className="cb-icon icon-expand_more" alt="Close Button" tabIndex={0} onKeyDown={({key}) => key === "Enter" ? handleChange() : ""} onClick={handleChange} />
                </span>:
                <label htmlFor={key} data-testid={`${testId}-label`} className={menuClass} onClick={handleChange} tabIndex={0} onKeyDown={({key}) => key === "Enter" ? handleChange() : ""}>
                    {props.title}
                    <i data-testid={`${testId}-dropdown`} className="cb-icon icon-expand_more" alt="Close Button" />
                </label>
            }
            
            <ul className="sub-group-list">
                {props.children}
            </ul>
        </li>
    )
}

export default CollapsibleMenu;